/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import { Injectable } from "@jack-henry/frontend-utils/di";
import { TmHttpClient } from "@treasury/core/http";
import { createSwaggerClient } from "../../utils/tm-swagger-client";

import { TermsAndConditionsModelDto } from "../";
import { ContentType, HttpClient, RequestParams } from "./http-client";

@Injectable()
export class TermsAndConditionsClient {
  private readonly http: HttpClient;

  constructor(tmHttp: TmHttpClient) {
    this.http = createSwaggerClient(tmHttp, HttpClient);
  }

  /**
   * No description
   *
   * @tags TermsAndConditions
   * @name TermsAndConditionsGet
   * @summary Retrieves the Terms and Conditions.
   * @request GET:/termsAndConditions
   */
  termsAndConditionsGet = (params: RequestParams = {}) =>
    this.http.request<TermsAndConditionsModelDto, any>({
      path: `/termsAndConditions`,
      method: "GET",
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags TermsAndConditions
   * @name TermsAndConditionsPost
   * @summary Posts terms and conditions.
   * @request POST:/termsAndConditions
   */
  termsAndConditionsPost = (
    data: TermsAndConditionsModelDto,
    params: RequestParams = {},
  ) =>
    this.http.request<TermsAndConditionsModelDto, any>({
      path: `/termsAndConditions`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
}
